import { getCurrentUserRole } from "modules/utilities/utility";
import api from "../../../api/index";

export function caseSearch(id) {
  const apiEndpoint = ["medrep_ext"].includes(getCurrentUserRole())
    ? `v3/caseSearch?key=${encodeURIComponent(id)}&moreInfo=true`
    : `caseSearchV2?key=${encodeURIComponent(id)}&moreInfo=true`;
  return api.get(apiEndpoint);
}

export function moveOrder(payload) {
  return api.put("move-order", payload);
}

// Track order(s) by AWB number or Order Display Id — pass exactly one.
// GET /track-order?awb=... | GET /track-order?orderDisplayId=...
// Returns { success, awb, orderDisplayId, orders: [...flat order objects], meta }.
export function trackOrder({ awb, orderDisplayId }) {
  const query = awb
    ? `awb=${encodeURIComponent(awb)}`
    : `orderDisplayId=${encodeURIComponent(orderDisplayId)}`;
  return api.get(`track-order?${query}`);
}

export function allOrders(query) {
  return api.get(`orders?${query}`);
}

export function orderDownload(queryParams) {
  return api.get(`download_all_orders${queryParams}`);
}

export function postAssignOrder(payload) {
  return api.post("assign_order", payload);
}
export function updateOrder(query, payload) {
  return api.put(`update-order-status?category=${query}`, payload);
}

export function openOrders(query) {
  return api.get(`admin_open_orders?${query}`);
}

export function openOrdersDownload(query) {
  return api.get(`download_admin_open_orders?${query}`);
}

export function recentOrderData(page) {
  return api.get(`orders?filterAssigned=true&pageNumber=${page}`);
}

export function recentOrderAssign(payload) {
  return api.post("assign_order", payload);
}

export function assignedDoctors(query) {
  return api.get(`assigned-doctors?${query}`);
}

export function getDoctorsList(params = {}) {
  const query = new URLSearchParams();
  query.append('role[]', 'doctor');
  query.append('role[]', 'clinic_doctor');
  if (params.breakdays_considered !== undefined) {
    query.append('breakdays_considered', params.breakdays_considered);
  }
  if (params.shift_considered !== undefined) {
    query.append('shift_considered', params.shift_considered);
  }
  return api.get(`doctors-list?${query.toString()}`);
}

export function ghostOrders(page){
  return api.get(`orders?status=ghost&pageNumber=${page}`)
}

export function warehousePincode(payload){
  return api.put(`update-pincode-mapping`, payload)
}

export const getEngagementHourly = (startDate, endDate) =>{
  return api.get(`agent-hourly-engagement?startDate=${startDate}&endDate=${endDate}`)
}
export const getReturnOrderDetails = (query) => {
  const { search, startDate = '', endDate = '', page = 1, limit = 10 } = query;
  return api.get(
    `api/returnRequests?search=${encodeURIComponent(search)}&startDate=${startDate}&endDate=${endDate}&page=${page}&limit=${limit}`
  );
};

export function updateOrderHistory(params) {
  return api.get(`get-bulk-order-processing-logs`, { params });
}

export function getCodToPrepaidData(page, size, resolvedType, paymentId) {
  let url = `/cod-to-prepaid?pageNumber=${page}&pageSize=${size}`;
  if (resolvedType) {
    url += `&resolvedType=${encodeURIComponent(resolvedType)}`;
  }
  if (paymentId) {
    url += `&paymentId=${encodeURIComponent(paymentId)}`;
  }
  return api.get(url);
}

export function codToPrepaidRefund(orderDisplayIdWithoutHash) {
  return api.post(`/cod-to-prepaid-refund?orderDisplayIdWithoutHash=${encodeURIComponent(orderDisplayIdWithoutHash)}`);
}

export function getCaseIdsByOrderId(orderDisplayId) {
  return api.get(`/get-case-ids-by-order-id?orderDisplayId=${encodeURIComponent(orderDisplayId)}`);
}

export function getCodToPrepaidStatus(orderDisplayId) {
  const orderIdWithoutHash = orderDisplayId?.replace("#", "");
  return api.get(`/order/cod-to-prepaid/${orderIdWithoutHash}?columns=payment_id,resolved_type`);
}

export function getExpectedDeliveryDate(orderDisplayId) {
  return api.get(`/get-expected-delivery-date`, { params: { orderDisplayId } });
}

export function getPreDispatchCodToPrepaidData(page, size, category, startDate, endDate, orderDisplayId, paymentId) {
  let url = `/cod-to-prepaid-pre-dispatch?pageNumber=${page}&pageSize=${size}`;
  if (category) {
    url += `&category=${encodeURIComponent(category)}`;
  }
  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (orderDisplayId) {
    url += `&orderDisplayId=${encodeURIComponent(orderDisplayId)}`;
  }
  if (paymentId) {
    url += `&paymentId=${encodeURIComponent(paymentId)}`;
  }
  return api.get(url);
}

export function getCrmPrepaidData(page, size, status, startDate, endDate, phone, gateway) {
  let url = `/crm-prepaid-link/admin/list?pageNumber=${page}&pageSize=${size}`;
  if (status) {
    url += `&status=${encodeURIComponent(status)}`;
  }
  if (startDate) {
    url += `&startDate=${encodeURIComponent(startDate)}`;
  }
  if (endDate) {
    url += `&endDate=${encodeURIComponent(endDate)}`;
  }
  if (phone) {
    url += `&phone=${encodeURIComponent(phone)}`;
  }
  if (gateway) {
    url += `&gateway=${encodeURIComponent(gateway)}`;
  }
  return api.get(url);
}

export function preDispatchCodToPrepaidRefund(orderDisplayIdWithoutHash) {
  return api.post(`/cod-to-prepaid-pre-dispatch/refund`, { orderDisplayId: orderDisplayIdWithoutHash });
}

// Delayed Comm endpoints are proxied by the internal-api server (API_URL_BASE) under
// /v1/delayed-comms/* and protected by authenticateJwt — the shared `api` client already
// attaches the logged-in user's Bearer token, so these go through it like every other call.
export function getDelayedCommsCategoryCounts(startDate, endDate) {
  let url = `/v1/delayed-comms/category-counts`;
  const params = [];
  if (startDate) params.push(`startDate=${encodeURIComponent(startDate)}`);
  if (endDate) params.push(`endDate=${encodeURIComponent(endDate)}`);
  if (params.length) url += `?${params.join("&")}`;
  return api.get(url);
}

export function getDelayedCommsOrdersByCategory(category, startDate, endDate, page, pageSize) {
  let url = `/v1/delayed-comms/orders-by-category?page=${page}&pageSize=${pageSize}`;
  if (category) url += `&category=${encodeURIComponent(category)}`;
  if (startDate) url += `&startDate=${encodeURIComponent(startDate)}`;
  if (endDate) url += `&endDate=${encodeURIComponent(endDate)}`;
  return api.get(url);
}

export function getInfluencerOrderLogs(params = {}) {
  return api.get('bulk/influencer-order/logs', { params })
    .catch((error) => {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        console.warn('No access to influencer order logs');
        return { data: { data: [], meta: { total_count: 0, total_pages: 1 } } };
      }
      throw error;
    });
}

export function getInfluencerOrderBatches(params = {}) {
  return api.get('bulk/influencer-order/batches', { params })
    .catch((error) => {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        console.warn('No access to influencer order batches');
        return { data: { data: [], meta: { total_count: 0, total_pages: 1 } } };
      }
      throw error;
    });
}

export function uploadBulkInfluencerOrders(formData) {
  return api.post('bulk/influencer-order', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function getOrderAddress(orderDisplayId) {
  return api.get(`order-address/${encodeURIComponent(orderDisplayId)}`);
}

export function updateOrderAddress(orderDisplayId, payload) {
  return api.put(`order-address/${encodeURIComponent(orderDisplayId)}`, payload);
}

